import React from 'react'
import { useAuth } from '../context/AuthContext.tsx'
import AccessDenied from './AccessDenied.tsx'
import { isAgencyAdmin, isSystemAdmin } from '../utils/roles.ts'

interface AgencyAdminAccessProps {
  children: React.ReactNode
}

const AgencyAdminAccess: React.FC<AgencyAdminAccessProps> = ({ children }) => {
  const { user } = useAuth()

  if (!isSystemAdmin(user) && !isAgencyAdmin(user)) {
    return (
      <AccessDenied message="You don't have permission to access this page. Agency Admin access required." />
    )
  }

  return <>{children}</>
}

export default AgencyAdminAccess
